module.exports = __webpack_public_path__ + "static/favicon-97bcad85a5a2df5bf449402d30764e62.ico";